export const apiConfig ={
  installer_token_list : 'api/installer_tokens/list',
  authorized_subcontractor_list : 'api/authorized_subcontractors/list',
  assign_to_subcontractor : 'api/installer_tokens/assign_to_subcontractor',
  purchase_token_cart : 'api/purchase_tokens/carts_url'
}